import classNames from 'classnames';
import { MaterialIcon } from '../MaterialIcon';
import { tagColor } from '../Tag';
import { CC_CARD_TEXT } from './utils';

type CcProductCardUrgencyPillProps = {
  label: string;
  /** Within 7 days the pill escalates in tone (FR-1.5.8). */
  urgent: boolean;
  /** The end date in words, for assistive tech: the visible label is only the count. */
  description: string;
};

export const CcProductCardUrgencyPill: React.FC<
  CcProductCardUrgencyPillProps
> = ({ label, urgent, description }) => (
  <span
    data-component="cc-product-card-urgency-pill"
    data-urgent={urgent}
    className={classNames(
      CC_CARD_TEXT.badge,
      'inline-flex items-center gap-spacing/gap/soft-4px whitespace-nowrap rounded-radius/tooltip px-spacing/padding/soft-6px py-0.5',
      tagColor(urgent ? 'red' : 'yellow'),
    )}
  >
    <MaterialIcon icon="alarm" px={12} />
    {label}
    <span className="sr-only">{description}</span>
  </span>
);
